import { WindowModule, DialogModule } from '@progress/kendo-angular-dialog';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ImportAlmDatasetComponent } from './import-alm-dataset/import-alm-dataset.component';
import { SimulationSetComponent } from './simulation-set/simulation-set.component';
import { BaselineDetailsComponent } from './simulation-set/baseline-details.component';
import { StressDetailsComponent } from './simulation-set/stress-details.component';
import { FormsModule } from '@angular/forms';
import { LoaderModule } from '@core/loader/loader.module';
import { MaterialModule } from '@core/material.module';
import { SpreadSheetsModule } from '@grapecity/spread-sheets-angular';
import { ImportErrorDisplayComponent } from './import-alm-dataset/import-error-display/import-error-display.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    CoreModule,
    LoaderModule,
    MaterialModule,
    SpreadSheetsModule,
    SharedModule,
    WindowModule,
    DialogModule,
  ],
  declarations: [
    ImportErrorDisplayComponent,
    ImportAlmDatasetComponent,
    SimulationSetComponent,
    BaselineDetailsComponent,
    StressDetailsComponent,
  ],
})
export class SimulationModule {}
